import React, { useContext } from 'react'

import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import { PencilFill, TrashFill } from 'react-bootstrap-icons'

const AttendeeInfo = ({ attendee, onEditClick, onDeleteClick }) => {
  if (!attendee) return null
  const showActions = onEditClick || onDeleteClick
  return (
    <Card>
      <Card.Body>
        <Row>
          <Col>
            <h6 className="signup__label--small">Name</h6>
            {attendee.firstName} {attendee.lastName}
          </Col>
          <Col>
            <h6 className="signup__label--small">Email</h6>
            {attendee.email}
          </Col>

          <Col>
            {attendee.phone && (
              <>
                <h6 className="signup__label--small">Telefon</h6>
                {attendee.phone}
              </>
            )}
          </Col>
        </Row>
        {attendee.separateBilling && (
          <>
            <Row className="mt-2">
              <Col>
                <h6 className="signup__label--small">Adresse</h6>
                {attendee.address1}
                {attendee.address2 && ', ' + attendee.address2}
                {', '}
                {attendee.zip} {attendee.city}
                {' ('}
                {attendee.country}
                {')'}
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <span className="signup__hint">
                  Dieser Teilnehmer übernimmt die Kosten selbst und
                  erhält eine eigene Rechnung.
                </span>
              </Col>
            </Row>
          </>
        )}
        {showActions && (
          <Row className="mt-3">
            <Col className="d-flex justify-content-end">
              {onEditClick && (
                <Button size="md" variant="outline-primary" style={{ borderRadius: '50%', border: 0 }} onClick={onEditClick}>
                  <PencilFill />
                </Button>
              )}
              {onDeleteClick && (
                <Button size="md" variant="outline-danger" style={{ borderRadius: '50%', border: 0 }} onClick={onDeleteClick}>
                  <TrashFill />
                </Button>
              )}
            </Col>
          </Row>
        )}
      </Card.Body>
    </Card>
  )
}

export default AttendeeInfo
